import { required, email, max, integer } from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'
import {
  isKana,
  isCellPhoneNumber,
  isPostalCode,
  isURL,
  isHiraGana,
  validLength
} from '@/utils/validate'

extend('name-required', {
  ...required,
  message: 'おなまえはひらがなで入力してください'
})

extend('hiragana', {
  message: 'おなまえはひらがなで入力してください',
  validate(value: string) {
    return isHiraGana(value)
  }
})

extend('clinic-required', {
  ...required,
  message: 'ご希望のクリニックを選択してください',
  validate: (value: { name: string}) => {
    if (value.name === null || value.name === '') {
      return false;
    }
    return true;
  }
})

extend('consultation-kind-required', {
  ...required,
  message: 'ご来院かオンラインかを選択してください'
})

extend('reservation-contents-required', {
  ...required,
  message: '初診予約、無料カウンセリングを選択してください',
})

extend('phone_number-required', {
  ...required,
  message: '電話番号を記載してください'
})

extend('phone_number', {
  message: '正しい電話番号（050,070,080,090）を記載してください',
  validate(value: string) {
    return isCellPhoneNumber(value)
  }
})

extend('phone_number-length', {
  message: '11字以内で入力してください',
  validate(value: string) {
    return validLength(value, 11)
  }
})

extend('email-required', {
  ...required,
  message: 'メールアドレスを記載してください'
})

extend('email', {
  ...email,
  message: '正しいメールアドレスを記載してください'
})

extend('email-length', {
  message: '256字以内で入力してください',
  validate(value: string) {
    return validLength(value, 256)
  }
})

extend('reservation-date-required', {
  ...required,
  message: 'ご予約日を選択してください'
})

extend('contact-tool-required', {
  ...required,
  message: '連絡方法を選択してください'
})

extend('required', {
  ...required,
  message: '必須項目です'
})

extend('email', {
  ...email,
  message: '正しいメールアドレスを入力してください'
})

extend('integer', {
  ...integer,
  message: '数字を入力してください'
})

extend('max', {
  ...max,
  message: '{length}文字以内で入力してください'
})

extend('url', {
  message: '正しいURLを入力してください',
  validate(value: string) {
    return isURL(value)
  }
})

extend('kana', {
  message: 'カタカナで入力してください',
  validate(value: string) {
    return isKana(value)
  }
})

extend('postal_code', {
  message: '正しい郵便番号（-なし）を入力してください',
  validate(value: string) {
    return isPostalCode(value)
  }
})

extend('cell_phone_number', {
  message: '正しい番号（-なし）を入力してください',
  validate(value: string) {
    return isCellPhoneNumber(value)
  }
})
